import Vue from "vue";
import Router from "vue-router";
import config from "@/config";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      component: () => import("@/views/default/index.vue"),
      children: [
        {
          path: "",
          redirect: "/login"
        },
        {
          path: "/login",
          component: () => import("@/views/default/_login.vue")
        },
        {
          path: "/logout",
          component: () => import("@/views/default/_logout.vue")
        },
        {
          path: "/expired",
          component: () => import("@/views/default/_expired.vue")
        },
        {
          path: "/denied",
          component: () => import("@/views/default/_denied.vue")
        }
      ]
    },
    {
      path: "/overview",
      component: () => import("@/views/_overview.vue"),
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.overview] }
    },
    {
      path: "/account",
      component: () => import("@/views/account/index.vue"),
      children: [
        {
          path: "/account",
          redirect: "/account/accountList"
        },
        {
          path: "/account/accountList",
          component: () => import("@/views/account/_accountList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account] }
        },
        {
          path: "/account/newAccount",
          component: () => import("@/views/account/_newAccount.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account] }
        },
        {
          path: "/account/memberTac",
          component: () => import("@/views/account/_memberTac.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account] }
        },
        {
          path: "/account/memberTacList",
          component: () => import("@/views/account/_memberTacList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account] }
        },
        {
          path: "/account/dailyMetrics",
          component: () => import("@/views/account/_dailyMetrics.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.account] }
        }
      ],
      meta: {
        requiredLoggedIn: true,
        includedPages: [config.accessRoles.overview]
      }
    },
    {
      path: "/ticket",
      component: () => import("@/views/ticket/index.vue"),
      children: [
        {
          path: "/ticket",
          redirect: "/ticket/ticketList"
        },
        {
          path: "/ticket/ticketList",
          component: () => import("@/views/ticket/_ticketList.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket] }
        },
        {
          path: "/ticket/pendingTicket",
          component: () => import("@/views/ticket/_pendingTicket.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket] }
        },
        {
          path: "/ticket/redepositTicket",
          component: () => import("@/views/ticket/_redepositTicket.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.ticket] }
        }
      ],
      meta: {
        requiredLoggedIn: true,
        includedPages: [config.accessRoles.overview]
      }
    },
    {
      path: "/bank",
      component: () => import("@/views/bank/index.vue"),
      children: [
        {
          path: "/bank/bankGroup",
          component: () => import("@/views/bank/_bankGroup.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bank] }
        },
        {
          path: "/bank/bankOperator",
          component: () => import("@/views/bank/_bankOperator.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bank] }
        },
        {
          path: "/bank/bankMember",
          component: () => import("@/views/bank/_bankMember.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bank] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.bank] }
    },
    {
      path: "/report",
      component: () => import("@/views/report/index.vue"),
      children: [
        {
          path: "/report",
          redirect: "/report/dailyWinLose"
        },
        {
          path: "/report/dailyWinLose",
          component: () => import("@/views/report/_dailyWinLose.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        },
        {
          path: "/report/dailyStatement",
          component: () => import("@/views/report/_dailyStatement.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        },
        {
          path: "/report/dailyEarning",
          component: () => import("@/views/report/_dailyEarning.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        },
        {
          path: "/report/dailyEarningByDate",
          component: () => import("@/views/report/_dailyEarningByDate.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        },
        {
          path: "/report/bankStatementMonthly",
          component: () => import("@/views/report/_bankStatementMonthly.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        },
        {
          path: "/report/bankStatementDaily",
          component: () => import("@/views/report/_bankStatementDaily.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        },
        {
          path: "/report/transferHistory",
          component: () => import("@/views/report/_transferHistory.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.report] }
    },
    {
      path: "/log",
      component: () => import("@/views/log/index.vue"),
      children: [
        {
          path: "/log/transferLog",
          component: () => import("@/views/log/_transferLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/accountLog",
          component: () => import("@/views/log/_accountLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/agentLoginLog",
          component: () => import("@/views/log/_agentLoginLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/memberLoginLog",
          component: () => import("@/views/log/_memberLoginLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/profileLog",
          component: () => import("@/views/log/_profileLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/authorityLog",
          component: () => import("@/views/log/_authorityLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/betLimitLog",
          component: () => import("@/views/log/_betLimitLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/betLimitSportsLog",
          component: () => import("@/views/log/_betLimitSportsLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        },
        {
          path: "/log/actionLog",
          component: () => import("@/views/log/_actionLog.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
        }
      ],
      meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.log] }
    },
    {
      path: "/system",
      component: () => import("@/views/system/index.vue"),
      children: [
        {
          path: "/system",
          redirect: "/system/page"
        },
        {
          path: "/system/function",
          component: () => import("@/views/system/_function.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.function] }
        },
        {
          path: "/system/page",
          component: () => import("@/views/system/_page.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.page] }
        },
        {
          path: "/system/role",
          component: () => import("@/views/system/_role.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.role] }
        },
        {
          path: "/system/user",
          component: () => import("@/views/system/_user.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.user] }
        },
        {
          path: "/system/setting",
          component: () => import("@/views/system/_setting.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.setting] }
        },
        {
          path: "/system/iplist",
          component: () => import("@/views/system/_iplist.vue"),
          meta: { requiredLoggedIn: true, includedPages: [config.accessRoles.iplist] }
        }
      ],
      meta: {
        requiredLoggedIn: true,
        includedPages: [config.accessRoles.function, config.accessRoles.page, config.accessRoles.role, config.accessRoles.user, config.accessRoles.setting]
      }
    }
  ]
});

export default router;
